import s from '../pages.scss';
import {
  SkeletonLine,
  SkeletonRectangle,
  Box,
  SkeletonGroup,
  Page,
} from '@wix/design-system';
import React from 'react';
import { useSiteContext, useUserContext } from '@wix/app-market-core';
import { AppsSectionsSkeleton } from '../../components/apps-sections-skeleton';

export function CategorySkeleton() {
  const { isMobile } = useUserContext();
  const { horizontalNav } = useSiteContext();

  if (horizontalNav) {
    return (
      <Page className={`${s.appMarketPage} ${s.appMarketPageBackgroundColor}`}>
        <Page.Content>
          <SkeletonGroup skin="light">
            <Box dataHook="skeleton-title" marginTop="24px">
              <SkeletonRectangle width="240px" height="28px" />
            </Box>
            <AppsSectionsSkeleton rows={2} boxCount={8} />
          </SkeletonGroup>
        </Page.Content>
      </Page>
    );
  }

  return (
    <Page className={`${s.appMarketPage} ${s.appMarketPageBackgroundColor}`}>
      <Page.Content>
        <SkeletonGroup skin="light">
          <Box
            dataHook="skeleton-header"
            marginTop="22px"
            align="space-between"
          >
            <Box dataHook="skeleton-header-text" direction="vertical">
              <Box dataHook="back-button-skeleton" marginLeft="4px">
                <SkeletonLine width="48px" />
              </Box>
              <Box
                dataHook="skeleton-titles"
                marginTop="20px"
                direction="vertical"
              >
                <SkeletonLine width={isMobile ? '112px' : '132px'} />
                <SkeletonRectangle
                  width={isMobile ? '222px' : '638px'}
                  height="30px"
                  marginTop="6px"
                />
              </Box>
            </Box>
          </Box>
          <AppsSectionsSkeleton rows={2} boxCount={8} />
        </SkeletonGroup>
      </Page.Content>
    </Page>
  );
}
